import * as L from 'leaflet';
import './style.sass';
import { createElementObject, createOverlayComponent, useLayerLifecycle, } from '@react-leaflet/core';
function createInfoBox(props, context) {
    const popup = L.popup({
        autoPan: true,
        maxHeight: 150,
        minWidth: 215,
    })
        .on('remove', props.onClose)
        .setLatLng(props.position)
        .setContent(props.unsafe_html_content)
        .openOn(context.map);
    return createElementObject(popup, context);
}
export const InfoBox = createOverlayComponent(createInfoBox, useLayerLifecycle);
